module.exports = __webpack_public_path__ + "img/36_18.b010acb7.png";